export const MANUAL_ZOOM_IN_EVENT = 'manual-zoom-in';
export const MANUAL_ZOOM_OUT_EVENT = 'manual-zoom-out';
export const RETURN_MAP_TO_CENTER_EVENT = 'sh-search-map-return-to-center';
